import { useWizard } from "react-use-wizard";
import buySteps from "../../buySteps";
import ViewRealtorParticipationStep from "../../../../../../../shared/wizard/steps/viewRealtorParticipationStep";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../../..";
import { EDealRequestViewType } from "../../../../../../../shared/wizard/steps/types";

interface ISureBuyStepBuy_3 {
  onChange: (
    data: EDealRequestViewType,
    key: TStringKeysOfIFillDataWizardBuy
  ) => void;
  data: EDealRequestViewType | null;
  isNextStepDisabled: boolean;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const SureBuyStepBuy_3 = ({
  data,
  isNextStepDisabled,
  onChange,
  onReset,
}: ISureBuyStepBuy_3) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.sureSteps.buy.step_2);
    onReset(["viewRealtorParticipation"]);
  };

  const handleNexStep = () => {
    goToStep(buySteps.sureSteps.buy.step_4);
  };

  return (
    <div>
      <ViewRealtorParticipationStep
        handlePrevStep={handlePrevStep}
        handleNexStep={handleNexStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
        mode="buy"
      />
    </div>
  );
};

export default SureBuyStepBuy_3;
